<template>
  <!-- Add -->
  <div
    class="modal fade"
    id="add_item"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ isEditMode ? "Update" : "Create" }} {{ title }}
          </h5>
          <div class="d-flex align-items-center">
            <button
              class="btn-close custom-btn-close border p-1 me-0 text-dark"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="ti ti-x"></i>
            </button>
          </div>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <!-- Input Fields -->
            <div class="mb-3">
              <label class="col-form-label"
                >Name <span class="text-danger">*</span></label
              >
              <input type="text" class="form-control" v-model="name" />
              <div class="text-danger" v-if="errors.name">
                {{ errors.name[0] }}
              </div>
            </div>
            <div class="mb-3">
              <label class="col-form-label"
                >Email <span class="text-danger">*</span></label
              >
              <input type="text" class="form-control" v-model="email" />
              <div class="text-danger" v-if="errors.email">
                {{ errors.email[0] }}
              </div>
            </div>
            <div class="mb-3">
              <label class="col-form-label"
                >Password <span class="text-danger">*</span></label
              >
              <input type="text" class="form-control" v-model="password" />
              <div class="text-danger" v-if="errors.password">
                {{ errors.password[0] }}
              </div>
            </div>
            <div class="mb-3">
              <label class="col-form-label"
                >Phone <span class="text-danger">*</span></label
              >
              <input type="text" class="form-control" v-model="phone" />
              <div class="text-danger" v-if="errors.phone">
                {{ errors.phone[0] }}
              </div>
            </div>
            <!-- <div class="mb-3">
              <label for="employeeSelect" class="col-form-label">Select Supervisor</label>
              <select id="employeeSelect" class="form-select" v-model="selectedSupervisor">
                <option value="">Select a Supervisor</option>
                <template v-for="employee in supervisors" :key="employee.id">
                  <option :value="employee.id">
                    {{ employee?.user?.name }}
                  </option>
                  
                  <SubSupervisors
                    v-if="employee.children_recursive && employee.children_recursive.length > 0"
                    :category="employee"
                    dot="----"
                  />
                </template>
              </select>
            </div> -->

            <div class="mb-3">
              <label for="employeeSelect" class="col-form-label"
                >Select a Supervisor</label
              >
              <select
                id="employeeSelect"
                class="form-select"
                v-model="selectedSupervisor"
                @focus="toggleSelect(true)"
                @blur="toggleSelect(false)"
              >
                <option
                  :style="{ color: isExpanded ? 'red' : 'black' }"
                  value=""
                >
                  {{
                    isExpanded ? "Unselect Supervisor" : "Select a Supervisor"
                  }}
                </option>
                <template v-for="employee in supervisors" :key="employee.id">
                  <option :value="employee.id">
                    {{ employee?.user?.name }}
                  </option>

                  <!-- Recursive Sub-Supervisors -->
                  <SubSupervisors
                    v-if="
                      employee.children_recursive &&
                      employee.children_recursive.length > 0
                    "
                    :category="employee"
                    dot="----"
                  />
                </template>
              </select>
            </div>

            <div class="mb-3">
              <label class="col-form-label"
                >Department <span class="text-danger">*</span></label
              >
              <multiselect
                v-model="selectedDepartment"
                :options="departments"
                track-by="name"
                label="name"
                placeholder="Select a department"
              >
              </multiselect>
            </div>
            <div class="mb-3">
              <label class="col-form-label"
                >Designation <span class="text-danger">*</span></label
              >
              <multiselect
                v-model="selectedDesignation"
                :options="designations"
                track-by="name"
                label="name"
                placeholder="Select a designation"
              >
              </multiselect>
            </div>
            <div class="mb-3">
              <label class="col-form-label"
                >Role <span class="text-danger">*</span></label
              >
              <multiselect
                v-model="selectedRole"
                :options="roles"
                track-by="name"
                label="name"
                placeholder="Select a role"
              >
              </multiselect>
            </div>
            <div class="mb-0">
              <label class="col-form-label">Address</label>
              <textarea
                class="form-control"
                rows="3"
                v-model="address"
              ></textarea>
              <div class="text-danger" v-if="errors.address">
                {{ errors.address[0] }}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-flex align-items-center justify-content-end m-0">
              <a href="#" class="btn btn-light me-2" data-bs-dismiss="modal"
                >Cancel</a
              >
              <button
                type="submit"
                class="btn btn-primary"
                :disabled="isLoading"
              >
                <span
                  v-if="isLoading"
                  class="spinner-border spinner-border-sm"
                ></span>
                {{ isEditMode ? "Update" : "Create" }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Add  -->

  <!-- Delete -->
  <div class="modal fade" id="delete_item" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="text-center">
            <div class="avatar avatar-xl bg-danger-light rounded-circle mb-3">
              <i class="ti ti-trash-x fs-36 text-danger"></i>
            </div>
            <h4 class="mb-2">Remove {{ title }}?</h4>
            <p class="mb-0">Are you sure you want to remove it</p>
            <div class="d-flex align-items-center justify-content-center mt-4">
              <a href="#" class="btn btn-light me-2" data-bs-dismiss="modal"
                >Cancel</a
              >
              <button
                class="btn btn-danger"
                @click="deleteItem()"
                :disabled="isLoading"
              >
                <span
                  v-if="isLoading"
                  class="spinner-border spinner-border-sm"
                ></span>
                Yes, Delete it
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete -->
</template>
<script>
import http from "@/utils/http";
import Multiselect from "vue-multiselect";
import SubSupervisors from "./SubSupervisors.vue";

export default {
  components: { Multiselect, SubSupervisors },
  props: {
    isEditMode: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    isLoading: false,
    name: "",
    email: "",
    password: "",
    phone: "",
    address: "",
    department_id: null,
    designation_id: null,
    role_id: null,
    itemId: null,
    errors: {},
    supervisors: [],
    selectedSupervisor: "",
    departments: [],
    selectedDepartment: {},
    designations: [],
    selectedDesignation: {},
    roles: [],
    selectedRole: {},
    isExpanded: false,
  }),
  watch: {
    selectedDepartment(newValue) {
      this.department_id = newValue?.id;
    },
    selectedDesignation(newValue) {
      this.designation_id = newValue?.id;
    },
    selectedRole(newValue) {
      this.role_id = newValue?.id;
    },
  },

  mounted() {
    this.$emitter.on("add-edit-item", (row) => {
      if (row) {
        console.log("row", row);
        this.itemId = row.id;
        this.name = row?.user?.name;
        this.email = row?.user?.email;
        this.phone = row.phone;
        this.address = row.address;
        this.department_id = row?.department_id;
        this.designation_id = row?.designation_id;
        this.role_id = row?.role_id;
        this.selectedSupervisor = row?.parent_id;
        this.selectedDepartment = row?.department;
        this.selectedDesignation = row?.designation;
        this.selectedRole = row?.role;
      }
      this.$handleModal("add_item", "toggle");
    });

    this.$emitter.on("delete-item-modal", (row) => {
      if (row) {
        this.itemId = row.id;
      }
      this.$handleModal("delete_item", "toggle");
    });

    this.getSupervisors();
    this.getDepartments();
    this.getDesignations();
    this.getRoles();
  },

  methods: {
    async getSupervisors() {
      const endpoint = `/get-employee-tree-view`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        const employees = response.data.contents;
        // this.supervisors = this.transformToTree(employees);
        this.supervisors = employees;
        console.log(this.supervisors, "asdadasdasdasdasdasd");
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    },

    toggleSelect(state) {
      this.isExpanded = state;
    },

    transformToTree(employees) {
      const map = {};
      const roots = [];
      employees.forEach((employee) => {
        map[employee.id] = { ...employee, children: [] };
      });
      employees.forEach((employee) => {
        if (employee.parent_id) {
          map[employee.parent_id]?.children.push(map[employee.id]);
        } else {
          roots.push(map[employee.id]);
        }
      });
      return roots;
    },

    getTreeOptions(node, level = 0) {
      const options = [];
      const prefix = "—".repeat(level); // Indentation for child nodes
      // options.push({ id: node.id, label: `${prefix} ${node.user.name}` });
      node.children.forEach((child) => {
        options.push({ id: child.id, label: `${prefix} ${child.user.name}` });
        options.push(...this.getTreeOptions(child, level + 1));
      });
      return options;
    },

    async submitForm() {
      this.isLoading = true;
      const endpoint = this.isEditMode
        ? `/employees/${this.itemId}`
        : "/employees";
      const method = this.isEditMode ? "put" : "post";
      let body = {
        name: this.name,
        email: this.email,
        password: this.password,
        phone: this.phone,
        address: this.address,
        parent_id: this.selectedSupervisor ? this.selectedSupervisor : "",
        department_id: this.department_id,
        designation_id: this.designation_id,
        role_id: this.role_id,
      };
      try {
        const response = await http[method](endpoint, body);
        this.$store.dispatch("fetchRolePermissions");
        this.$toast.success(response.data.message);
        this.$handleModal("add_item", "hide");
        this.$emit("refresh");
        this.isLoading = false;
      } catch (error) {
        this.errors = error.response.data.errors;
        this.isLoading = false;
      } finally {
        this.isLoading = false;
      }
    },
    async deleteItem() {
      this.isLoading = true;
      const endpoint = `/employees/${this.itemId}`;
      const method = "delete";
      try {
        const response = await http[method](endpoint);
        this.$toast.success(response.data.message);
        this.$handleModal("delete_item", "hide");
        this.$emit("refresh");
      } catch (error) {
        this.$toast.error(error.response.data.message);
      } finally {
        this.isLoading = false;
      }
    },
    //get departments, designations, roles
    async getDepartments() {
      const endpoint = `/departments`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.departments = response.data.contents;
        console.log("departments", response.data.contents);
      } catch (error) {
        //
      }
    },
    async getDesignations() {
      const endpoint = `/designations`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.designations = response.data.contents;
      } catch (error) {
        //
      }
    },
    async getRoles() {
      const endpoint = `/roles`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.roles = response.data.contents;
      } catch (error) {
        //
      }
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
